import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import CoffeeHeader from '../components/coffee/CoffeeHeader';
import CoffeeFilters from '../components/coffee/CoffeeFilters';
import CoffeeList from '../components/coffee/CoffeeList';
import CreateCoffeeModal from '../components/coffee/CreateCoffeeModal';
import { XIcon } from 'lucide-react';
const EIISCoffeePage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState<'all' | 'upcoming' | 'mine' | 'past'>('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTopic, setSelectedTopic] = useState('all');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  return <div className="flex h-screen bg-gray-100" data-id="element-1681">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-1682">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1683"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-1684">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-1685">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-1686">
              <span className="sr-only" data-id="element-1687">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-1688" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-1689">
            <Sidebar activePage="community" data-id="element-1690" />
          </div>
        </div>
      </div>
      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-1691">
        <Sidebar activePage="community" data-id="element-1692" />
      </div>
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1693">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-1694" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-1695">
          <div className="pt-4 md:pt-6 max-w-6xl mx-auto" data-id="element-1696">
            <CoffeeHeader onCreateClick={() => setIsCreateModalOpen(true)} data-id="element-1697" />
            <div className="mt-6" data-id="element-1698">
              <CoffeeFilters activeFilter={activeFilter} setActiveFilter={setActiveFilter} searchQuery={searchQuery} setSearchQuery={setSearchQuery} selectedTopic={selectedTopic} setSelectedTopic={setSelectedTopic} data-id="element-1699" />
            </div>
            <div className="mt-6" data-id="element-1700">
              <CoffeeList activeFilter={activeFilter} searchQuery={searchQuery} selectedTopic={selectedTopic} data-id="element-1701" />
            </div>
          </div>
        </main>
      </div>
      {/* Create Coffee Modal */}
      <CreateCoffeeModal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} data-id="element-1702" />
    </div>;
};
export default EIISCoffeePage;